module.exports = __webpack_public_path__ + "static/Product-card-06.bf1b48c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Product-card-06.png
// module id = ./src/images/Product-card-06.png
// module chunks = 4016850265702045000